export enum MainRoutes {
    MAIN = "/",
    SCAN = "/scan",
    EXPLORER = "/explorer",
    REDEEM = "/redeem/:type",
    PROGRAMS = "/programs",
    PROGRAM_DETAILS = "/program-details",
    PROFILE = "/profile",
    SEND_AND_RECEIVE = "/send-and-receive/:type",
    PARTNERS = "/partners",
    PARTNER_DETAILS = "/partner-details",
    GIFT_CARDS = "/giftcards",
    GIFT_CARDS_DETAILS = "/giftcards/:id",
    GIFT_CARDS_REDEEM = "/giftcards/:id/redeem/:amount",
    SEND_OTP_CODE_VERIFICATION = "/giftcards/otp",
    GIFT_CARDS_PURCHASED = "/giftcards/purchased",
}
